// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4091":"679344dbc787a4d8","7789":"f48a9359d805a9b2"}[chunkId] + ".js";
};